import { Button } from '@civilgrid/ui/components';
import { Link, useParams } from '@tanstack/react-router';
import type { ReactNode } from 'react';
import type { ProjectDetailsParams } from '..';

interface Props {
  children: ReactNode;
}

export default function UpgradeButton({ children }: Props) {
  const { projectId } = useParams({ strict: false }) as ProjectDetailsParams;
  return (
    <div className="my-2">
      <Button asChild variant="secondary" data-testid="project-summary-upgrade-button">
        <Link to="/projects/$projectId/$tabId" params={{ projectId, tabId: 'details' }}>
          Upgrade to {children}
        </Link>
      </Button>
    </div>
  );
}
